import { IconButton } from "@material-ui/core";
import i18next from "../../../assets/i18n/i18n";
import React, { MouseEventHandler } from "react";
import "../buttons.scss";

type Props = {
    onDecouple: MouseEventHandler;
};

const ButtonConfirmDecouple = ({ onDecouple }: Props): React.ReactElement => {
    return (
        <IconButton id="BtnConfirmDecouple" className="btn primary-btn" onClick={onDecouple}>
            <p className="btn-label">{i18next.t("Buttons.ConfirmDecouple")}</p>
        </IconButton>
    );
};

export default ButtonConfirmDecouple;
